module.exports = "<p style=\"    margin-top: 10px;\" (click)=\"$event.stopPropagation(); $event.preventDefault();\">\n  {{duration}}\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/playlist-duration/playlist-duration.component.html
// module id = ./src/app/shared/playlist-duration/playlist-duration.component.html
// module chunks = main